module.exports = __webpack_public_path__ + "img/star.c2416372.svg";